module.exports = __webpack_public_path__ + "img/credit-card.dd86fd26.png";